import React, { createContext, useContext, useRef } from 'react';

interface FormContextType {
	triggerSave: () => void;
	registerSaveHandler: (handler: () => void) => void;
}

const FormContext = createContext<FormContextType | null>(null);

export { FormContext };

export const useFormContext = () => {
	const context = useContext(FormContext);
	if (!context) {
		throw new Error('useFormContext must be used within a FormProvider');
	}
	return context;
};

interface FormProviderProps {
	children: React.ReactNode;
}

export const FormProvider: React.FC<FormProviderProps> = ({ children }) => {
	const saveHandlerRef = useRef<(() => void) | null>(null);

	const registerSaveHandler = (handler: () => void) => {
		saveHandlerRef.current = handler;
	};

	const triggerSave = () => {
		if (saveHandlerRef.current) {
			saveHandlerRef.current();
		}
	};

	return (
		<FormContext.Provider value={{ triggerSave, registerSaveHandler }}>
			{children}
		</FormContext.Provider>
	);
};